import * as React from 'react';
import ProjectComment from 'src/entities/ProjectComment';
import ProjectCommentCardContainer from 'src/modules/project/partials/comments/ProjectCommentCard.container';
import ProjectCommentInputComponent from 'src/modules/project/partials/comments/ProjectCommentInput.component';
import Project from 'src/entities/Project';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';

export interface ProjectCommentsComponentProps {
  projectComments?: ProjectComment[];
  newComment: string;
  project: Project;
  invest: boolean;
  closedProject: boolean;
  handleChange: (value: string) => void;
  handleSubmit: () => void;
}

class ProjectCommentListComponent extends React.PureComponent<ProjectCommentsComponentProps> {

  public render(): React.ReactNode {
    return (
      <div className="col-sm-9">
        <div className="padding-left-30">
          <div className="gap-50"/>
          <h3>
            Comentarios de la operación
          </h3>
        </div>
        {this.props.projectComments ? this.props.projectComments!.map(
          (projectComment, index) => (
            <section key={index}>
              <ProjectCommentCardContainer
                comment={projectComment}
              />
              <hr/>
            </section>
          )
        ) : null}
        <div className="gap-20"/>
        <ProjectCommentInputComponent
          comment={this.props.newComment}
          handleChange={this.props.handleChange}
          handleSubmit={this.props.handleSubmit}
        />
        <div className="gap-50"/>
        <ProjectActionToolbarContainer
          project={this.props.project}
          invest={this.props.invest}
          closedProject={this.props.closedProject}
        />
        <div className="gap-50"/>
      </div>
    );
  }

}

export default ProjectCommentListComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/comments/ProjectCommentList.component.tsx